// extracted by mini-css-extract-plugin
module.exports = {"plus":"Option_plus__00Ky_","hidden":"Option_hidden__kJFsL"};